import React, { useEffect, useState } from 'react'
import { useContext } from 'react'
import EventContext from '../contexts/EventContext'


import Packs from './Packs_v2'

import useApiUrlTranslation from './useApiUrlTranslation';
import { useParams } from 'react-router-dom/cjs/react-router-dom';

const PacksPublic = () => {

    const [pageTitle, setPageTitle] = useState('');
    const [pageSubtitle, setPageSubtitle] = useState('');
    const [tiers, setTiers] = useState([]);
    const [sections, setSections] = useState([]);

    const { t, i18n } = useApiUrlTranslation();

    const { idEvent } = useParams();

    // on lit toujours le contexte mais on décide ensuite quoi en faire

    const { currentEvent } = useContext(EventContext) || null;

    const tiers_fr = [
        { name: 'Cannes global experience', id: 'global', priceMonthly: '1 190€', mostPopular: true, href: `/events/2015/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1REYT9BO68gVmJAUryP1aIne` },
        { name: 'Cannes Tech4movies circle', id: 'circle', priceMonthly: '1 590€', mostPopular: false, href: `/events/2015/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1REYSTBO68gVmJAUCuw00LIP` },
        { name: 'tech4movies Exhibitor deck', id: 'exhibitor', priceMonthly: '4 490€', mostPopular: false, href: `/events/2015/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1REYTmBO68gVmJAUZ9vXYcSi` },
        {
            name: 'Tech4movies Official Partner', id: 'partner', priceMonthly: '12 000€', mostPopular: false,
            href: `/events/2015/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1REYUNBO68gVmJAU9bEn6ZsU`,
            href_: `/events/2015/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1RGh4yBO68gVmJAUdG70CFhA`
        },
    ]


    // global 1, circle 2, exhibitor 3, partner 4
    const tiersAnnuel_fr_2025 = [
        { name: 'GAME CHANGER FREEMIUM', id: 1, priceMonthly: '1 190€', mostPopular: true, href: `/events/2015/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1REYT9BO68gVmJAUryP1aIne` },
        { name: 'GAME CHANGER PREMIUM', id: 2, priceMonthly: '1 590€', mostPopular: false, href: `/events/2015/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1REYSTBO68gVmJAUCuw00LIP` },
        { name: 'GAME CHANGER UNLIMITED', id: 3, priceMonthly: '4 490€', mostPopular: false, href: `/events/2015/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1REYTmBO68gVmJAUZ9vXYcSi` },
    ]


    const tiers_2144_fr = [
        { name: 'PASS 3 JOURS', id: 1, priceMonthly: '750€', mostPopular: false, href: `/events/2144/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1T41d4BO68gVmJAUxA62vf8j` },
        { name: 'PASS 5 JOURS', id: 2, priceMonthly: '890€', mostPopular: true, href: `/events/2144/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1T41gRBO68gVmJAUuwFWDjlI` },
        { name: 'PASS FULL FESTIVAL (15 JOURS)', id: 3, priceMonthly: '1 590€', mostPopular: false, href: `/events/2144/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1T41iBBO68gVmJAULtByKhW6` },
        { name: 'PASS PREMIUM PARTNER', id: 4, priceMonthly: '3 990€', mostPopular: false, href: `/events/2144/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1T41jOBO68gVmJAUyJiaxSlc` },
    ]

    const tiers_2144_en = [
        { name: '3 DAYS PASS', id: 1, priceMonthly: '750€', mostPopular: false, href: `/events/2144/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1T41d4BO68gVmJAUxA62vf8j` },
        { name: '5 DAYS PASS', id: 2, priceMonthly: '890€', mostPopular: true, href: `/events/2144/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1T41gRBO68gVmJAUuwFWDjlI` },
        { name: 'FULL FESTIVAL PASS (15 DAYS)', id: 3, priceMonthly: '1 590€', mostPopular: false, href: `/events/2144/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1T41iBBO68gVmJAULtByKhW6` },
        { name: 'PREMIUM PARTNER', id: 4, priceMonthly: '3 990€', mostPopular: false, href: `/events/2144/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1T41jOBO68gVmJAUyJiaxSlc` },
    ]

    const sectionsAnnuel_fr = [

        {
            name: ' ',
            features: [
                { name: 'PASS MARCHÉ DU FILM (HIGHLIGHT AND SPECIAL EVENTS)', tiers: { 1: "3 days", 2: "5 days", 3: "15 days", 4: "2 pass 15 days" } },
                {
                    name: 'TECHXPLORATION CIRCLE & INDIVIDUAL INTERVIEW ON TECH4MOVIE WEBCAST STUDIO', tiers: {
                        1: "1",
                        2: "1 ",
                        3: '2',
                        4: '5'
                    }
                },
                {
                    name: 'NETWORKING WITH MYGLOBALVILLAGE IMPORT/EXPORT COORDINATOR ON CONNECT THE ENTERTAINEMENT HUB',
                    tiers: {
                        1: true,
                        2: true,
                        3: true,
                        4: true
                    }
                },
                {
                    name: 'ACCESS AS JUDGE OR PITCHING PLAYERS TO THE TECH4MOVIES GLOBALSHOW OFFICIAL QUALIFICATION / FINAL ON STAGE', tiers: {
                        1: false,
                        2: true,
                        3: true,
                        4: true
                    }
                },
                {
                    name: "EXPOSURE AND SPEECH OPPORTUNITY",
                    tiers: {
                        1: "On studio",
                        2: "On studio",
                        3: "On studio",
                        4: "On studio &on stage"
                    }
                },
                {
                    name: "SCREENING OF ALL FESTIVAL DE CANNES AND RED CARPET MOVIES",
                    tiers: {
                        3: "1 accreditation",
                        4: "2 accreditations"
                    }

                }, {
                    name: "VIP GALA ACCESS ON PLAGE DES PALMES",
                    tiers: {
                        4: "1 pass"
                    }

                },
            ],
        },


    ]

    const sections_2144_fr = [
        {
            name: ' ',
            features: [
                { name: 'PASS MARCHÉ DU FILM (ÉVÉNEMENTS PHARES ET SPÉCIAUX)', tiers: { 1: "3 jours", 2: "5 jours", 3: "15 jours", 4: "2 pass 15 jours" } },
                {
                    name: 'CERCLE TECHXPLORATION & INTERVIEW INDIVIDUELLE SUR LE STUDIO WEBCAST TECH4MOVIE',
                    tiers: {
                        1: "1",
                        2: "1",
                        3: '2',
                        4: '5'
                    }
                },
                {
                    name: 'MISE EN RÉSEAU AVEC LE COORDINATEUR IMPORT/EXPORT MYGLOBALVILLAGE SUR CONNECT THE ENTERTAINMENT HUB',
                    tiers: {
                        1: true,
                        2: true,
                        3: true,
                        4: true
                    }
                },
                {
                    name: 'ACCÈS EN TANT QUE JUGE OU PARTICIPANT AU PITCHING POUR LA QUALIFICATION OFFICIELLE / FINALE SUR SCÈNE DU TECH4MOVIES GLOBALSHOW',
                    tiers: {
                        1: false,
                        2: true,
                        3: true,
                        4: true
                    }
                },
                {
                    name: "VISIBILITÉ ET OPPORTUNITÉ DE PRISE DE PAROLE",
                    tiers: {
                        1: "En studio",
                        2: "En studio",
                        3: "En studio",
                        4: "En studio & sur scène"
                    }
                },
                {
                    name: "PROJECTION DE TOUS LES FILMS DU FESTIVAL DE CANNES ET DES MONTÉES DES MARCHES",
                    tiers: {
                        3: "1 accréditation",
                        4: "2 accréditations"
                    }
                },
                {
                    name: "ACCÈS VIP GALA SUR LA PLAGE DES PALMES",
                    tiers: {
                        4: "1 pass"
                    }
                },
            ],
        },
    ]


    const sections_2144_en = [

        {
            name: ' ',
            features: [
                { name: 'PASS MARCHÉ DU FILM (HIGHLIGHT AND SPECIAL EVENTS)', tiers: { 1: "3 days", 2: "5 days", 3: "15 days", 4: "2 pass 15 days" } },
                {
                    name: 'TECHXPLORATION CIRCLE & INDIVIDUAL INTERVIEW ON TECH4MOVIE WEBCAST STUDIO', tiers: {
                        1: "1",
                        2: "1 ",
                        3: '2',
                        4: '5'
                    }
                },
                {
                    name: 'NETWORKING WITH MYGLOBALVILLAGE IMPORT/EXPORT COORDINATOR ON CONNECT THE ENTERTAINEMENT HUB',
                    tiers: {
                        1: true,
                        2: true,
                        3: true,
                        4: true
                    }
                },
                {
                    name: 'ACCESS AS JUDGE OR PITCHING PLAYERS TO THE TECH4MOVIES GLOBALSHOW OFFICIAL QUALIFICATION / FINAL ON STAGE', tiers: {
                        1: false,
                        2: true,
                        3: true,
                        4: true
                    }
                },
                {
                    name: "EXPOSURE AND SPEECH OPPORTUNITY",
                    tiers: {
                        1: "On studio",
                        2: "On studio",
                        3: "On studio",
                        4: "On studio &on stage"
                    }
                },
                {
                    name: "SCREENING OF ALL FESTIVAL DE CANNES AND RED CARPET MOVIES",
                    tiers: {
                        3: "1 accreditation",
                        4: "2 accreditations"
                    }

                }, {
                    name: "VIP GALA ACCESS ON PLAGE DES PALMES",
                    tiers: {
                        4: "1 pass"
                    }

                },
            ],
        },


    ]


    const sections_fr = [

        {
            name: 'Access to marché du film and screening Cannes film festival',
            features: [
                { name: 'Pass Conférences & networking  : Cannes Next et Marché du Film. Accès au Palais des Festivals', tiers: { circle: "Pass d'accès Marché du Film et Cannes next 9 jours", global: "Pass d'accès Marché du Film et Cannes next 3 jours", exhibitor: "Pass d'accès Marché du Film et Cannes next 9 jours", partner: '2 pass 3 jours  + 2 pass 9 jours' } },
                { name: 'Accès aux projections des +300 films du Festival de Cannes (compétions officielle, quinzaine des réalisateurs, etc.) (+300 films)  du 13 au 24 mai', tiers: { circle: "1 accréditation - Accès à la plateforme de réservation des projections des films du festival de Cannes", global: false, exhibitor: '2 accréditations - Accès à la plateforme de réservation des projections des films du festival de Cannes', partner: "3 accréditations - Accès à la plateforme de réservation des projections des films du festival de Cannes " } },

            ],
        },
        {
            name: 'myGloblavillgae sourcing and landing program',
            features: [
                { name: 'Accès à la communauté Tech4Movies (circle of investors, vendors, distributors…)', tiers: { circle: true, global: true, exhibitor: true, partner: true } },
                { name: 'Intervention dans le Webcast thématique de votre choix ', tiers: { circle: '1 prise de parole', global: '1 prise de parole', exhibitor: '2 prises de parole', partner: '4 prises de parole pour votre organisation ou vos invités' } },
                { name: 'Accès au session de préqualification pour la session de pitch GlobalShow', tiers: { circle: true, global: true, exhibitor: true, partner: true } },
                { name: 'GlobalHow best of the world Pitch on Palais Stage if pre selected by your country delegation', tiers: { circle: 'Si votre solution est sélectionnée', global: 'Si votre solution est sélectionnée', exhibitor: 'Si votre solution est sélectionnée', partner: 'Accès aux membres du jury de préselection des solutions' } },
            ],
        },
        {
            name: "Possibilité d'exposer sur l'événement ",
            features: [
                { name: 'Table sur l’espace Espace Connect Hub – Marché du Film ', tiers: { circle: false, global: false, exhibitor: 'Table chaises, raccordement electrique sur la zone expo du 13 au 21 mai', partner: false } },
                { name: 'Visibilité, cocktail et photos de l’espace Connect', tiers: { circle: false, global: false, exhibitor: "Accès aux temps forts, séance photos du l'espace connect du 13 au 21 mai", partner: true } },
            ],
        },
        {
            name: 'Visibilité et label',
            features: [
                { name: 'Label myglobalvillage Cannes nominated solution or official judges (selon votre profil)', tiers: { circle: "1 solution présentée", global: "1 solution présentée", exhibitor: "2 solutions présentées", partner: "3 solutions présentées et membres des jurés de pré-selection" } },
                { name: 'Sponsoring d’un temps fort ou d’un webcast au choix', tiers: { circle: false, global: false, exhibitor: false, partner: "Partenaires Officiels du webcast de votre choix" } },
                { name: 'Visibilité média & digitale sur les supports myGlobalVillage & partners', tiers: { circle: false, global: false, exhibitor: "Sur les supports de communication de l'espace Connect", partner: "Prise de parole ou diffusion d'une video de 30 secondes lors des webcast" } },
                { name: 'Logo et descriptif de votre solution, visibilité de votre organisation/entreprise', tiers: { circle: "Présence sur l'annuaire des solutions tech4movies de myglobalvillage", global: "Présence sur l'annuaire des solutions tech4movies de myglobalvillage", exhibitor: "Sur les supports de communication de l'espace Connect", partner: "Sur 100%  des supports de communication de l'espace Connect et de l'annuaire myGlobalVillage" } },
            ],
        },
        {
            name: 'Soirée VIP Cannes Gala',
            features: [
                { name: 'Cannes Gala Diner & ceremony (Plage des Palmes)', tiers: { circle: false, global: false, exhibitor: false, partner: '2 personnes - Soirée exclusive' } },

            ],
        },
    ]

    const tiers_en = [
        {
            name: 'Cannes Global Experience',
            id: 'global',
            priceMonthly: '€1,190',
            mostPopular: true,
            href: `/events/2015/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=en&price_id=price_1REYT9BO68gVmJAUryP1aIne`
        },
        {
            name: 'Cannes Tech4Movies Circle',
            id: 'circle',
            priceMonthly: '€1,590',
            mostPopular: false,
            href: `/events/2015/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=en&price_id=price_1REYSTBO68gVmJAUCuw00LIP`
        },
        {
            name: 'Tech4Movies Exhibitor Deck',
            id: 'exhibitor',
            priceMonthly: '€4,490',
            mostPopular: false,
            href: `/events/2015/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=en&price_id=price_1REYTmBO68gVmJAUZ9vXYcSi`
        },
        {
            name: 'Tech4Movies Official Partner',
            id: 'partner',
            priceMonthly: '€12,000',
            mostPopular: false,
            href: `/events/2015/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1REYUNBO68gVmJAU9bEn6ZsU`,
            href_: `/events/2015/signup/delegation-myglobalvillage-c/?form-name=delegation-myglobalvillage-c&formisvisible=1&id_formulaire=86&lng=fr&price_id=price_1RGh4yBO68gVmJAUdG70CFhA`
        },
    ];

    const sections_en = [
        {
            name: 'Access to Film Market & Cannes Film Festival Screenings',
            features: [
                {
                    name: 'Film Market & Cannes Next conference pass + networking events',
                    tiers: {
                        circle: '9‑day Film Market & Cannes Next pass',
                        global: '3‑day Film Market & Cannes Next pass',
                        exhibitor: '9‑day Film Market & Cannes Next pass',
                        partner: '2 × 3‑day + 2 × 9‑day passes'
                    }
                },
                {
                    name: 'Access to 300+ Cannes Film Festival screenings (Official Competition, Directors’ Fortnight, etc.) May 13–24',
                    tiers: {
                        circle: '1 accreditation – access to the Cannes screening reservation platform',
                        global: false,
                        exhibitor: '2 accreditations – access to the Cannes screening reservation platform',
                        partner: '3 accreditations – access to the Cannes screening reservation platform'
                    }
                }
            ]
        },
        {
            name: 'myGlobalVillage Sourcing & Landing Program',
            features: [
                {
                    name: 'Access to the Tech4Movies community (investors, vendors, distributors…)',
                    tiers: { circle: true, global: true, exhibitor: true, partner: true }
                },
                {
                    name: 'Speaking slot in one thematic webcast of your choice',
                    tiers: {
                        circle: '1 speaking slot',
                        global: '1 speaking slot',
                        exhibitor: '2 speaking slots',
                        partner: '4 speaking slots for your organization or guests'
                    }
                },
                {
                    name: 'Access to pre‑qualification sessions for the GlobalShow pitch',
                    tiers: { circle: true, global: true, exhibitor: true, partner: true }
                },
                {
                    name: 'GlobalShow “Best of the World” pitch on Palais Stage if pre‑selected by your delegation',
                    tiers: {
                        circle: 'If your solution is selected',
                        global: 'If your solution is selected',
                        exhibitor: 'If your solution is selected',
                        partner: 'Access to pre‑selection jury members'
                    }
                }
            ]
        },
        {
            name: 'Exhibition Opportunities',
            features: [
                {
                    name: 'Table at the Connect Hub – Film Market',
                    tiers: {
                        circle: false,
                        global: false,
                        exhibitor: 'Table, chairs, and power hookup in the expo area May 13–21',
                        partner: false
                    }
                },
                {
                    name: 'Connect space visibility, cocktail & photo sessions',
                    tiers: {
                        circle: false,
                        global: false,
                        exhibitor: 'Access to highlight events & photo sessions at the Connect space May 13–21',
                        partner: true
                    }
                }
            ]
        },
        {
            name: 'Visibility & Branding',
            features: [
                {
                    name: '“myGlobalVillage Cannes” nominated solution or official judge label (based on profile)',
                    tiers: {
                        circle: '1 solution featured',
                        global: '1 solution featured',
                        exhibitor: '2 solutions featured',
                        partner: '3 solutions featured + pre‑selection jury membership'
                    }
                },
                {
                    name: 'Sponsorship of a highlight event or webcast of your choice',
                    tiers: { circle: false, global: false, exhibitor: false, partner: 'Official webcast partner of your choice' }
                },
                {
                    name: 'Media & digital visibility on myGlobalVillage & partner channels',
                    tiers: {
                        circle: false,
                        global: false,
                        exhibitor: 'Featured in Connect space communications',
                        partner: '30‑sec video or speaking slot during webcasts'
                    }
                },
                {
                    name: 'Logo & solution/business description visibility',
                    tiers: {
                        circle: 'Listed in the Tech4Movies solutions directory',
                        global: 'Listed in the Tech4Movies solutions directory',
                        exhibitor: 'Featured in Connect space communications',
                        partner: 'Featured in all Connect space & myGlobalVillage directory communications'
                    }
                }
            ]
        },
        {
            name: 'VIP Cannes Gala Evening',
            features: [
                {
                    name: 'Cannes Gala Dinner & Ceremony (Plage des Palmes)',
                    tiers: {
                        circle: false,
                        global: false,
                        exhibitor: false,
                        partner: '2 seats – exclusive evening'
                    }
                }
            ]
        }
    ];


    useEffect(() => {

        if (!currentEvent) {


            console.log('currentEvent:', currentEvent)

            if (i18n.language == 'fr') {


                setSections(sections_2144_fr)
                setTiers(tiers_2144_fr)
                setPageTitle(' Cannes tech4movies meetup - Offre  de participation 2026')
                setPageSubtitle('Participez à myGlobalVillage. Bénéficiez d’un accès privilégié, d’une visibilité internationale, de connexions ciblées et d’opportunités business concrètes.')
                // setBoutonAcheter('Acheter')
            } else {

                setSections(sections_2144_en)
                setTiers(tiers_2144_en)
                setPageTitle('Participation Offers – Tech4Movies Meetup (Cannes 2026)')
                setPageSubtitle('Join myGlobalVillage – Tech4Movies Meetup, the international rendezvous of technologies for cinema and audiovisual at the heart of the Cannes Film Market. Benefit from privileged access, international visibility, targeted connections and concrete business opportunities.')
                // setBoutonAcheter('Buy')
            }
        }
        else if (currentEvent) {


            if (currentEvent.id_event == 2015) {

                if (i18n.language === 'fr') {
                    setSections(sections_fr)
                    setTiers(tiers_fr)
                    setPageTitle(' Offres de Participation – Tech4Movies Meetup (Cannes 2025)')
                    setPageSubtitle('Participez à myGlobalVillage – Tech4Movies Meetup, le rendez-vous international des technologies au service du cinéma et de l’audiovisuel au cœur du Marché du Film de Cannes. Bénéficiez d’un accès privilégié, d’une visibilité internationale, de connexions ciblées et d’opportunités business concrètes.')
                    // setBoutonAcheter('Acheter')
                } else {
                    setSections(sections_en)
                    setTiers(tiers_en)
                    setPageTitle('Participation Offers – Tech4Movies Meetup (Cannes 2025)')
                    setPageSubtitle('Join myGlobalVillage – Tech4Movies Meetup, the international rendezvous of technologies for cinema and audiovisual at the heart of the Cannes Film Market. Benefit from privileged access, international visibility, targeted connections and concrete business opportunities.')
                    // setBoutonAcheter('Buy')
                }
            } else if (currentEvent.id_event == 2144) {


                if (i18n.language === 'fr') {
                    setSections(sections_2144_fr)
                    setTiers(tiers_2144_fr)
                    setPageTitle(' Offres de Participation – Tech4Movies Meetup (Cannes 2026)')
                    setPageSubtitle('Participez à myGlobalVillage – Tech4Movies Meetup, le rendez-vous international des technologies au service du cinéma et de l’audiovisuel au cœur du Marché du Film de Cannes. Bénéficiez d’un accès privilégié, d’une visibilité internationale, de connexions ciblées et d’opportunités business concrètes.')
                    // setBoutonAcheter('Acheter')
                } else {
                    setSections(sections_2144_en)
                    setTiers(tiers_2144_en)
                    setPageTitle('Participation Offers – Tech4Movies Meetup (Cannes 2026)')
                    setPageSubtitle('Join myGlobalVillage – Tech4Movies Meetup, the international rendezvous of technologies for cinema and audiovisual at the heart of the Cannes Film Market. Benefit from privileged access, international visibility, targeted connections and concrete business opportunities.')
                    // setBoutonAcheter('Buy')
                }
            }

            else if (currentEvent.id_event == 2118) {

                if (i18n.language === 'fr') {
                    setSections(sections_fr)
                    setTiers(tiers_fr)
                    setPageTitle(' Offres de Participation – Tech4Movies Meetup (Cannes 2025)')
                    setPageSubtitle('Participez à myGlobalVillage – Tech4Movies Meetup, le rendez-vous international des technologies au service du cinéma et de l’audiovisuel au cœur du Marché du Film de Cannes. Bénéficiez d’un accès privilégié, d’une visibilité internationale, de connexions ciblées et d’opportunités business concrètes.')
                    // setBoutonAcheter('Acheter')
                } else {
                    setSections(sections_en)
                    setTiers(tiers_en)
                    setPageTitle('Participation Offers – Tech4Movies Meetup (Cannes 2025)')
                    setPageSubtitle('Join myGlobalVillage – Tech4Movies Meetup, the international rendezvous of technologies for cinema and audiovisual at the heart of the Cannes Film Market. Benefit from privileged access, international visibility, targeted connections and concrete business opportunities.')
                    // setBoutonAcheter('Buy')
                }
            }

        }




    }
        , [i18n.language, currentEvent]);


    return (
        <div>



            <Packs
                sections={sections}
                tiers={tiers}
                pageTitle={pageTitle}
                pageSubtitle={pageSubtitle}

            /></div>
    )
}

export default PacksPublic